import { FlatViewOrderSinglePageDesktop, ICallbackParams } from '@cian/newbuilding-flat-view-order-component';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { getFlatTourBookingSchedule } from '../../selectors/newbuildingFlatTourBooking';

interface INewbuildingFlatTourBookingModalContainerProps {
  newbuildingName: string;
  isOpen: boolean;
  onSubmit(params: ICallbackParams): Promise<boolean>;
  onSuccess(params: ICallbackParams): void;
  onClose(): void;
}

const NewbuildingFlatTourBookingModalContainer: React.FC<INewbuildingFlatTourBookingModalContainerProps> = ({
  newbuildingName,
  isOpen,
  onClose,
  onSuccess,
  onSubmit,
}) => {
  const schedule = useSelector(getFlatTourBookingSchedule);
  const { config } = useApplicationContext();

  const privacyPolicyUrl = config.get<string>('callback-widget.privacyPolicyUrl') || undefined;
  const marketingAgreementUrl = config.get<string>('callback-widget.marketingAgreementUrl') || undefined;
  const personalDataAgreementUrl = config.get<string>('callback-widget.personalDataAgreementUrl') || undefined;
  const isMarketingAgreementEnabled = config.get<boolean>('Newbuilding.Core.MarketingAgreement.Enabled') || false;

  if (!schedule) {
    return null;
  }

  return (
    <FlatViewOrderSinglePageDesktop
      isOpen={isOpen}
      onSubmit={onSubmit}
      onSuccess={onSuccess}
      onClose={onClose}
      disabledDays={schedule.disabledDays}
      availableDates={schedule.availableDates}
      newbuildingName={newbuildingName}
      minDate={schedule.minDate}
      maxDate={schedule.maxDate}
      nextDate={schedule.nextDate}
      nextNextDate={schedule.nextNextDate}
      privacyPolicyUrl={privacyPolicyUrl}
      marketingAgreementUrl={marketingAgreementUrl}
      personalDataAgreementUrl={personalDataAgreementUrl}
      isMarketingAgreementEnabled={isMarketingAgreementEnabled}
    />
  );
};

// oxlint-disable-next-line import/no-default-export
export default NewbuildingFlatTourBookingModalContainer;
